import React, { useState, useEffect } from "react";
import styles from "./SectionModal.module.css";
import { FiX } from "react-icons/fi";
import {
  createSections,
  getIcons,
  updateSections,
} from "../../../api/HttpApis";
import { showToast } from "../../../utils/Toastify/Toastify";

export default function SectionModal({
  isOpen,
  onClose,
  initialData = null,
  fetchSection,
  onSaved,
}) {
  const [form, setForm] = useState({
    name: "",
    slug: "",
    icon: "",
  });

  const [iconOpen, setIconOpen] = useState(false);
  const [icons, setIcons] = useState([]);
  const [slugTouched, setSlugTouched] = useState(false);


  const fetchIcons = async () => {
    try {
      const response = await getIcons();
      setIcons(response?.data);
    } catch (error) {
      showToast(
        error?.response?.data?.message || "Error fetching icons",
        "error"
      );
    }
  };
  const slugify = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "") 
      .replace(/\s+/g, "-") 
      .replace(/-+/g, "-") 
      .replace(/^-|-$/g, ""); 

  useEffect(() => {
    if (isOpen) {
      fetchIcons();
      setSlugTouched(false);

    }

    if (initialData) {
      setForm({
        name: initialData.name,
        slug: initialData.slug,
        icon: initialData.icon || "",
      });
    } else if (isOpen) {
      setForm({
        name: "",
        slug: "",
        icon: "",
      });
    }
  }, [initialData, isOpen]);

  if (!isOpen) return null;

 

  const handleChange = (e) => {
    const { name, value } = e.target;

    
    if (name === "name") {
      const generatedSlug = slugify(value);

      setForm((prev) => ({
        ...prev,
        name: value,
        slug: slugTouched ? prev.slug : generatedSlug,
      }));
      return;
    }

    if (name === "slug") {
      setSlugTouched(true);
      setForm((prev) => ({
        ...prev,
        slug: slugify(value),
      }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };


  const save = async () => {
    if (!form.name?.trim()) {
      showToast("Page name is required", "error");
      return;
    }

    try {
      let response;
      if (initialData) {
        response = await updateSections(initialData.id, form);
      } else {
        // New pages start as a draft -- they only go Live once the admin
        // explicitly hits Publish from the builder's topbar.
        response = await createSections({ ...form, is_active: false });
      }

      if (response?.data?.status === "success") {
        showToast(
          initialData ? "Page updated — publish to update the site" : "Page created successfully",
          "success"
        );
      }

      if (!initialData) {
        onSaved?.({ name: form.name, is_active: false, pageId: response?.data?.data?.id });
      }
      fetchSection();
      onClose();
    } catch (error) {
      showToast(
        error?.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>{initialData ? "Edit Page" : "Add New Page"}</h2>
          <FiX className={styles.closeIcon} onClick={onClose} />
        </div>

        <div className={styles.body}>
          <label>Page Name</label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            className={styles.input}
            placeholder="Enter page name"
          />

          {/* <label>URL Slug</label>
          <input
            type="text"
            name="slug"
            value={form.slug}
            onChange={handleChange}
            className={styles.input}
            placeholder="Enter URL slug"
          /> */}

          <label>Icon</label>

          <div className={styles.iconSelectWrapper}>
            {/* Selected Icon */}
            <div
              className={styles.iconSelect}
              onClick={() => setIconOpen((prev) => !prev)}
            >
              <div className={styles.selectedIcon}>
                {form.icon ? (
                  <img
                    src={form.icon}
                    alt="selected icon"
                    className={styles.selectedIconImg}
                    width={16}
                  />
                ) : (
                  <span className={styles.placeholder}>Select Icon</span>
                )}
              </div>

              <span
                className={`${styles.dropdownArrow} ${
                  iconOpen ? styles.rotate : ""
                }`}
              >
                ▼
              </span>
            </div>

            {/* Icon Dropdown */}
            {iconOpen && (
              <div className={styles.iconDropdown}>
                {icons.map((item) => (
                  <img
                    key={item.name}
                    src={item.url}
                    alt={item.name}
                    className={`${styles.iconOption} ${
                      form.icon === item.url ? styles.active : ""
                    }`}
                    onClick={() => {
                      setForm((prev) => ({ ...prev, icon: item.url }));
                      setIconOpen(false);
                    }}
                    title={item.name}
                  />
                ))}
              </div>
            )}
          </div>
        </div>

        <div className={styles.footer}>
          <button className={styles.btnGhost} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.btnPrimary} onClick={save}>
            Save Page
          </button>
        </div>
      </div>
    </div>
  );
}
